import { c as _c } from "react/compiler-runtime";
import { ArrowLeft, ChevronRight, KeyRound, LogOut, Mail, Trash2, UserCog } from "lucide-react";
import { BrandCardHeader } from "#/components/brand/BrandCardHeader";
import { Button } from "#/components/ui/button";
import { Card, CardContent } from "#/components/ui/card";
import { Separator } from "#/components/ui/separator";
import { StatusMessage } from "#/components/ui/status-message";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function ProfileInfo(t0) {
  const $ = _c(7);
  const {
    user
  } = t0;
  const t1 = user?.name;
  let t2;
  if ($[0] !== t1) {
    t2 = /*#__PURE__*/_jsx("div", {
      className: "text-sm font-medium",
      children: t1
    });
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = user?.email;
  let t4;
  if ($[2] !== t3) {
    t4 = /*#__PURE__*/_jsx("div", {
      className: "text-xs text-muted-foreground",
      children: t3
    });
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t2 || $[5] !== t4) {
    t5 = /*#__PURE__*/_jsxs("div", {
      className: "flex flex-col items-center space-y-1 text-center",
      children: [t2, t4]
    });
    $[4] = t2;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
}
function NavigationButton(t0) {
  const $ = _c(12);
  const {
    icon: Icon,
    label,
    onClick,
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "default" : t1;
  const variantClasses = variant === "destructive" ? "hover:bg-destructive/10 hover:text-destructive text-destructive" : "hover:bg-muted";
  const t2 = `${"w-full justify-between rounded-lg border p-3 text-sm"} ${variantClasses}`;
  let t3;
  if ($[0] !== Icon) {
    t3 = /*#__PURE__*/_jsx(Icon, {
      className: "h-4 w-4"
    });
    $[0] = Icon;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== label) {
    t4 = /*#__PURE__*/_jsx("span", {
      children: label
    });
    $[2] = label;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t3 || $[5] !== t4) {
    t5 = /*#__PURE__*/_jsxs("div", {
      className: "flex items-center gap-2",
      children: [t3, t4]
    });
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = /*#__PURE__*/_jsx(ChevronRight, {
      className: "h-4 w-4"
    });
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== onClick || $[9] !== t2 || $[10] !== t5) {
    t7 = /*#__PURE__*/_jsxs(Button, {
      variant: "ghost",
      className: t2,
      onClick: onClick,
      children: [t5, t6]
    });
    $[8] = onClick;
    $[9] = t2;
    $[10] = t5;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
}
export default function AccountSettingsCard(t0) {
  const $ = _c(34);
  const {
    user,
    onSignOut,
    onBack,
    onEditProfile,
    onChangePassword,
    onChangeEmail,
    onDeleteAccount,
    statusMessage,
    isLoading: t1
  } = t0;
  const isLoading = t1 === undefined ? false : t1;
  if (!user) {
    return null;
  }
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = /*#__PURE__*/_jsx(BrandCardHeader, {
      title: "Kontoinst\xE4llningar",
      subtitle: "Hantera dina kontoinst\xE4llningar och preferenser"
    });
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== user) {
    t3 = /*#__PURE__*/_jsx(ProfileInfo, {
      user: user
    });
    $[1] = user;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = /*#__PURE__*/_jsx(Separator, {});
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== onEditProfile) {
    t5 = /*#__PURE__*/_jsx(NavigationButton, {
      icon: UserCog,
      label: "Redigera profil",
      onClick: onEditProfile
    });
    $[4] = onEditProfile;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== onChangePassword) {
    t6 = /*#__PURE__*/_jsx(NavigationButton, {
      icon: KeyRound,
      label: "\xC4ndra l\xF6senord",
      onClick: onChangePassword
    });
    $[6] = onChangePassword;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== onChangeEmail) {
    t7 = /*#__PURE__*/_jsx(NavigationButton, {
      icon: Mail,
      label: "\xC4ndra e-post",
      onClick: onChangeEmail
    });
    $[8] = onChangeEmail;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== onDeleteAccount) {
    t8 = /*#__PURE__*/_jsx(NavigationButton, {
      icon: Trash2,
      label: "Radera konto",
      onClick: onDeleteAccount,
      variant: "destructive"
    });
    $[10] = onDeleteAccount;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = /*#__PURE__*/_jsx(Separator, {
      className: "my-2"
    });
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = /*#__PURE__*/_jsx(LogOut, {
      className: "mr-2 h-4 w-4"
    });
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== isLoading || $[15] !== onSignOut) {
    t11 = /*#__PURE__*/_jsxs(Button, {
      variant: "outline",
      className: "w-full",
      onClick: onSignOut,
      disabled: isLoading,
      children: [t10, "Logga ut"]
    });
    $[14] = isLoading;
    $[15] = onSignOut;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = /*#__PURE__*/_jsx(ArrowLeft, {
      className: "mr-2 h-4 w-4"
    });
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== isLoading || $[19] !== onBack) {
    t13 = /*#__PURE__*/_jsxs(Button, {
      variant: "outline",
      className: "w-full",
      onClick: onBack,
      disabled: isLoading,
      children: [t12, "Tillbaka"]
    });
    $[18] = isLoading;
    $[19] = onBack;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== t11 || $[22] !== t13 || $[23] !== t5 || $[24] !== t6 || $[25] !== t7 || $[26] !== t8) {
    t14 = /*#__PURE__*/_jsxs("div", {
      className: "space-y-2",
      children: [t5, t6, t7, t8, t9, t11, t13]
    });
    $[21] = t11;
    $[22] = t13;
    $[23] = t5;
    $[24] = t6;
    $[25] = t7;
    $[26] = t8;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== statusMessage) {
    t15 = statusMessage && /*#__PURE__*/_jsx(StatusMessage, {
      message: statusMessage.message,
      variant: statusMessage.variant
    });
    $[28] = statusMessage;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== t14 || $[31] !== t15 || $[32] !== t3) {
    t16 = /*#__PURE__*/_jsxs(Card, {
      className: "m-auto w-screen overflow-y-auto rounded-none bg-card shadow-none sm:max-h-[calc(100vh-112px)] sm:max-w-md sm:rounded-lg sm:shadow-lg sm:shadow-zinc-500/10",
      children: [t2, /*#__PURE__*/_jsxs(CardContent, {
        className: "space-y-6 p-4",
        children: [t3, t4, t14, t15]
      })]
    });
    $[30] = t14;
    $[31] = t15;
    $[32] = t3;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  return t16;
}